import { requestHelpers } from '../../../helpers';

const actions = {
    GET_CURRENT_COURSE: 'GET_CURRENT_COURSE',
    SET_CURRENT_COURSE: 'SET_CURRENT_COURSE',
    GET_COURSES: 'GET_COURSES',
    SET_COURSES: 'SET_COURSES',
    GET_COURSE_LOCATIONS: 'GET_COURSE_LOCATIONS',
    SET_COURSE_LOCATIONS: 'SET_COURSE_LOCATIONS',
    GET_CURRENT_COURSE_MODULES: 'GET_CURRENT_COURSE_MODULES',
    SET_CURRENT_COURSE_MODULES: 'SET_CURRENT_COURSE_MODULES',
};

function getCurrentCourse( courseId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_COURSE,
            courseId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/training/courses/${ courseId }` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_COURSE,
                    course: response.data,
                } );
            } );
    }
}

function getCurrentCourseModules( courseId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_CURRENT_COURSE_MODULES,
            courseId,
        } );
        requestHelpers
            .authenticatedGetRequest( `/training/courses/${ courseId }/modules` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_CURRENT_COURSE_MODULES,
                    modules: response.data,
                } );
            } );
    }
}

function getCourses( networkId, page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_COURSES,
            networkId,
        } );

        requestHelpers
            .authenticatedGetRequest( '/training/courses', { page } )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_COURSES,
                    courses: response.data,
                    pagination: response.meta,
                } );
            } );
    }
}

module.exports = {
    getCurrentCourse,
    getCourses,
    getCurrentCourseModules,
    actions
};



// WEBPACK FOOTER //
// src/client/actions/training/courses/courses.js